import get from 'lodash/get';
import { createSelector } from 'reselect/lib/index';

export const communitiesJoinRequestsSelector = state =>
  get(state, 'communities.communitiesJoinRequests');

export const sendingCommunitiesJoinRequestsSelector = createSelector(
  communitiesJoinRequestsSelector,
  request => get(request, 'sending', false),
);

export const makeNotificationListSelector = notificationList =>
  createSelector(
    communitiesJoinRequestsSelector,
    request => get(request, notificationList, []),
  );

export const makeNotificationListCounterSelector = notificationType =>
  createSelector(
    communitiesJoinRequestsSelector,
    request => {
      const counterName = `${notificationType}NotificationsCount`;

      return get(request, ['meta', counterName], null);
    },
  );

export const makeNotificationPaginationSelector = type =>
  createSelector(
    communitiesJoinRequestsSelector,
    state => get(state, ['pagination', type]),
  );

export const selectNewNotifications = createSelector(
  makeNotificationListSelector('member'),
  state => {
    return state.map(item => {
      if (get(item, 'status') === 'unread') {
        return get(item, ['subject', 'community', 'id']);
      }
      return false;
    });
  },
);



// WEBPACK FOOTER //
// ./src/redux/communities/selectors/communitiesJoinRequests.js